import { MenuItem } from "@/app/components/form-fields/select/MenuItem";
import { RootMenuFull } from "@/app/components/form-fields/select/RootMenu";
import { SubMenuFull } from "@/app/components/form-fields/select/SubMenu";
import { ISelectFieldOption } from "@/app/fields/types";
import { splitOptionLevels } from "@/app/utils/splitOptionLevels";
import React from "react";

export const MultiLevelSelect = ({
  options,
  isInvalid,
  isDisabled,
  onBlur,
  label,
  onOptionClick,
  onClear,
}: {
  options: ISelectFieldOption[];
  isInvalid: boolean;
  label: React.ReactNode;
  isDisabled?: boolean;
  onBlur?: () => void;
  onOptionClick: (value: ISelectFieldOption) => void;
  onClear?: () => void;
}) => {
  const groups = splitOptionLevels(options);
  return (
    <RootMenuFull
      isInvalid={isInvalid}
      isDisabled={isDisabled}
      label={label}
      onBlur={onBlur}
      onClear={onClear}
    >
      {groups.length > 1
        ? groups.map((group) =>
            group._options.length > 1 ? (
              <SubMenuFull label={group.label} key={group.value}>
                {(group._options ? group._options : []).map((option) => (
                  <MenuItem
                    data-cy={`custom-select-option-${option.value}`}
                    label={option.label}
                    key={option.value}
                    onClick={() => onOptionClick(option)}
                  />
                ))}
              </SubMenuFull>
            ) : (
              <MenuItem
                data-cy={`custom-select-option-${group._options[0].value}`}
                label={group._options[0].label}
                key={group._options[0].value}
                onClick={() => onOptionClick(group._options[0])}
              />
            )
          )
        : options.map((option) => (
            <MenuItem
              data-cy={`custom-select-option-${option.value}`}
              label={option.label}
              key={option.value}
              onClick={() => onOptionClick(option)}
            />
          ))}
    </RootMenuFull>
  );
};
